import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { MessagesService }         from '../messages.service';
import { MessengerService }        from '../messenger/messenger.service';
import { MessengerSmsParamsModel } from './typings/messenger.sms-params';
import { TemplatedWordingService } from '../../templates/templated-wording.service';
import { TemplateModel }           from '../../templates/typings/template';
import { ValidationsService }      from '../../sessions/validations.service';

@Component({
  selector   : 'messenger-sms',
  template: require('./messenger.sms.component.html')
})
export class MessengerSmsComponent {
  @BlockUI('messengerSmsBlock') block : NgBlockUI;

  @Input() sms : MessengerSmsParamsModel;

  constructor (
    public  activeModal            : NgbActiveModal,
    private messagesService        : MessagesService,
    @Inject(forwardRef(() => MessengerService))
    private messengerService       : MessengerService,
    private templatedWordingService: TemplatedWordingService,
    private translateService       : TranslateService,
    private validationsService     : ValidationsService
  ) {}

  addTemplates () : void {
    this.templatedWordingService.addTemplate('sms')
    .then(( templates : Array<TemplateModel> ) => {
      templates.forEach(template => {
        this.sms.message = this.sms.message
          ? `${ this.sms.message }\n\n${ template.wording }`
          : template.wording;
      });
    });
  }

  isPhoneNumberValid () : boolean {
    return this.validationsService.isPhoneNumberValid(this.sms.send_to, true);
  }

  send () : void {
    if ( !this.isPhoneNumberValid() ) {
      this.messagesService.error(this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.MOBILE_NUMBER_NOT_CORRECT'));
    }
    else if ( this.sms.modalOnly ) {
      this.activeModal.close(this.sms);
    }
    else {
      this.block.start();

      this.messengerService.sendSms(this.sms)
      .then(() => this.activeModal.close(this.sms))
      .catch(err => this.messagesService.error(err))
      .finally(() => this.block.stop());
    }
  }
}
